import categoryFunctions from './serie-design/serie-category-functions';

document.addEventListener("DOMContentLoaded", () => {
    categoryFunctions.init();
});